import React from 'react'
import styled from 'styled-components'
import { BreakingWidth, FlexVerticalContainer, HeaderHeight } from './var'

const StyledHeroIntro = styled(FlexVerticalContainer).attrs<{ className?: string }>((props) => ({
  className: props.className,
}))<{ autoHeight?: boolean }>`
  color: #fff;
  ${({ autoHeight }) => (!autoHeight ? `height: calc(100vh - ${HeaderHeight});` : null)}
  margin: 0 auto;

  @media (max-width: ${BreakingWidth.lg}) {
    height: auto;
    width: 100vw;
    text-align: center;
  }

  h1 {
    font-size: 52px;
    font-weight: bold;
    color: currentColor;
  }

  p {
    font-size: 28px;
    line-height: 26px;
  }
`

export const HeroIntro: React.FC<{ autoHeight?: boolean; className?: string }> = ({ autoHeight, className }) => (
  <StyledHeroIntro autoHeight className={className}>
    <h1>SHENMA Credit</h1>
    <p>Anytime, Anywhere</p>
  </StyledHeroIntro>
)
